export enum CapsuleEventType {
  NEW = 'NEW',
  BECAME_CERTAIN = 'BECAME_CERTAIN',
  EXTINCT = 'EXTINCT',
}
